import moment from 'moment';

export default function IsJuvenile(date) {
  const momentDate = moment(new Date(date));

  if (momentDate.isValid() === false) {
    return false;
  }

  return momentDate.add(18, 'years').isAfter();
}